import { render } from "./NotRights.vue?vue&type=template&id=02378266&scoped=true"
const script = {}

import "./NotRights.vue?vue&type=style&index=0&id=02378266&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02378266"]])

export default __exports__